import type { IconData } from '@stacksjs/iconify-core'

export const bagSuitcase4: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M3.586 14.236c.21-2.133 1.67-3.848 3.785-4.196C10.353 9.548 15.57 9 24 9s13.647.548 16.63 1.04c2.114.348 3.575 2.063 3.784 4.196C44.69 17.033 45 21.426 45 27s-.31 9.967-.586 12.764c-.21 2.133-1.67 3.848-3.785 4.196C37.647 44.452 32.43 45 24 45s-13.646-.548-16.63-1.04c-2.114-.348-3.575-2.063-3.784-4.196C3.31 36.967 3 32.574 3 27s.31-9.967.586-12.764\"/><path d=\"M44.986 24.972C39.6 26.67 28.47 30 24 30S8.4 26.67 3.014 24.972M16.738 9.2c.457-1.408 1.238-3.052 1.824-4.204c.478-.938 1.34-1.615 2.384-1.755A23 23 0 0 1 24 3.045c1.245 0 2.278.091 3.053.196c1.044.14 1.906.817 2.384 1.755c.586 1.152 1.367 2.796 1.824 4.203\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default bagSuitcase4
